import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname: string = "User";

  //Display
  formmode:string="Add";
  
   //Mode Values
   isaddmode:boolean=false;
   iseditmode:boolean=false;
   isdeletemode:boolean=false;
   isviewmode:boolean=false;

   isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   

  
   //Save Validation
   submitted:boolean;
   successfully:boolean;
   saveloading: boolean;

  show: boolean;
  
   //Edit Get Values
   userColl:any=[];
   userBO:any={};

   userid:number=0
   
   userroleColl:any=[]

   userform=new FormGroup({
    userid:new FormControl(0),          
    usercode:new FormControl(''),  
    username:new FormControl('',Validators.required),  
    password:new FormControl('',Validators.required),  
     inactive: new FormControl(false),  
     logoimage:new FormControl(null),
     userroleid: new FormControl(null,Validators.required),
     signatureimage: new FormControl(null),
   });
  
    //set image
    image;
    strImage: any;
    picurl:string="";
    picname: string = "";
    
  

    signatureimage;
    signaturestrImage: any;
    signaturepicurl: string = "";
    signaturepicname: string = "";
  
  
  
  constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
      public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
        this.route.queryParams.subscribe(params => {
          if(params.id!==undefined){
            this.userid = params.id
          }          
        });
  
        this.fnServiceChanges();
  }
  
    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
  
    });
  }
  
  
  
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
  
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnOnInitForm() {
      try{
          this.isaddmode=true;
          this.userform.reset();
          this.fnInitializeFormGroup(); 
  
          if(this.userid>0){
            this.fngetUser();
          }
          this.fngetUserRole()
      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.userid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm() {
    this.isprivilage = true;
  }  
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup(){
      this.userform.setValue({
        userid:0,    
        usercode:'',
        username:'',
        password:'',
        inactive: false , 
        logoimage:null,
        userroleid: null,
        signatureimage: null,
      })
  }
  
  //Get 
  fngetUser() {
    if (this.showProgress) {
      return;
    }         
        var data = {
          'userid':this.userid,
          'companyid':this.loginService.fnGetCompanyId()          
        }
        this.appService.getUser(data)
        .subscribe(
          (res)=>{                
            if(res.json().status===200){  
              this.fnHideProgress();

              this.userColl=res.json().result;
              var editdata = this.userColl[0];        
              this.fnEditMode(editdata);
              this.userBO=editdata;
            }
            else {
              this.fnHideProgress();

              this.loginService.fnAPIError(res.json())
            }
            
        },
        (err)=>{
          this.fnHideProgress();
          
          this.toastr.error('Error', err);
        })
  }
  fngetUserRole() {        
    var data = {
      'userroleid':0,
      'companyid':this.loginService.fnGetCompanyId()          
    }
    this.appService.getUserRole(data)
    .subscribe(
      (res)=>{                
        if(res.json().status===200){  
          this.userroleColl=res.json().result;
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
        
    },
    (err)=>{          
      this.toastr.error('Error', err);
    })
}
  
  
  //Save Btn Click
  fnSaveBtnClick(){
      try{
        if (this.saveloading) {
          return;
        }
  
        this.submitted=true;
        this.successfully=false;
        //Validate
        if(this.userform.valid){ this.saveloading = true;

            //Check
            var data = {
                  'userid': this.userid,                      
                  'username':this.userform.get('username').value, 
                  'usercode':this.userform.get('usercode').value, 
                  'passwd':this.userform.get('password').value,    
                  'userroleid':this.userform.get('userroleid').value, 
                  'inactive': this.userform.get('inactive').value, 
                  logoimage: this.strImage,
              logoimgpath: this.picurl,  
              signatureimage: this.signaturestrImage,
              signatureimgpath: this.signaturepicurl,
                  'companyid':this.loginService.fnGetCompanyId(),
                  'createdby': this.loginService.fnGetModUserId(),  
                 'modifiedby':this.loginService.fnGetModUserId(),                                                              
            }
  
          
            this.appService.fnCheckUser(data).subscribe(
              (res)=>{
                if(res.json().status===200){  
                  var _checkresult=res.json().result[0].checkfield;
                
                  if(_checkresult==="done"){
                        if (this.userform.get('userid').value>0){
                          //Update 
                          this.fnSetUser(data);
                        }
                        else{
                          //Insert 
                          this.fnInsertUser(data);
                        }
                  }
                  else{        
                        if(_checkresult==="name"){ this.saveloading = false;

                          this.userform.controls['usercode'].setErrors({'notfound': true});
                        }
                  }
                }
                else { this.saveloading = false;

                  this.loginService.fnAPIError(res.json())
                }
            },
            (err)=>{ this.saveloading = false;

                this.toastr.error('Error', err);           
            });
         }
      }catch(ex){ this.saveloading = false;

        this.fnShowErrorMsg(ex);
      }
  }
  
  //Insert
  fnInsertUser(data){    
    
      this.appService.fnInsertUser(data).subscribe(
        (res)=>{ this.saveloading = false;

          if(res.json().status===200){  
            if(res.json().result!=""){
              this.toastr.success('', "The new user has been added successfully.Insert Successfully");
              this.fnInsertActivityLog('INSERT', 0, data.username);

              this.fnCloseForm();
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
      },
        (err)=>{ this.saveloading = false;

          this.toastr.error('Error', err);
        });
  
  }
  
  //Set
  fnSetUser(data){    
  
  this.appService.fnSetUser(data).subscribe(
    (res)=>{ this.saveloading = false;

      if(res.json().status===200){  
            if(res.json().result!=""){
                this.toastr.success('', "The user has been updated successfully.");
                this.fnInsertActivityLog('EDIT',this.userid,data.username);
                this.fnCloseForm();        
            } 
        }
      else {
        this.loginService.fnAPIError(res.json())
      }
    },
    (err)=>{ this.saveloading = false;

      this.toastr.error('Error', err);
    });
  
  }
  
  //Close
  fnCloseForm(){
  try{
     this.router.navigate(['/User']);
  }catch(ex){
      this.fnShowErrorMsg(ex);
  }
  }
  
  private fnEditMode(deptBO){
    this.userform.setValue({ 
      userid:deptBO.userid, 
      userroleid:deptBO.userroleid,
      usercode:deptBO.usercode, 
      username:deptBO.username,
      password:deptBO.passwd,
      inactive:deptBO.inactive,
      logoimage: null,
      signatureimage: null,
    });
  
    this.picurl =deptBO.logoimgpath;   
  
    this.signaturepicurl = deptBO.signaturepath;
    
    this.formmode="Edit";
      
    this.iseditmode=true;
    this.isdeletemode=false;
    this.isviewmode=false;
  }
  

  
fnShowpassword(event) {
 
  this.show = !this.show;
}

  
 //Image Import
 changeListener($event): void {
  try{
     this.readThis($event.target);
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
  }
  
  readThis(inputValue: any): void {
  
   var file: File = inputValue.files[0];
   var myReader: FileReader = new FileReader();
  
   myReader.onloadend = (e) => {
       this.image = myReader.result;
       this.strImage = this.image.split(',')[1];
   }
   myReader.readAsDataURL(file);
  }
  
  removeimage(){
   this.image =null;
   this.strImage =null;
   this.picurl="";
  }
  
  fnOpenFileBrowser(event:any){
  
    event.preventDefault();
  
    let element:HTMLElement=document.getElementById('image') as HTMLElement;
    element.click();
  
  }

  

  
  //Signature Import
  changeListenerSignature($event): void {
    try {
      this.readThisSignature($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThisSignature(inputValue: any): void {
    
    var file: File = inputValue.files[0];


    var myReader: FileReader = new FileReader();
    

    myReader.onloadend = (e) => {
      this.signatureimage = myReader.result;
      this.signaturestrImage = this.signatureimage.split(',')[1];
            
    }
    myReader.readAsDataURL(file);
  }

  removeimageSignature() {
    this.signatureimage = null;
    this.signaturestrImage = null;
    this.signaturepicurl = "";
  }

  fnOpenFileBrowserSignature(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('signatureimage') as HTMLElement;
    element.click();

  }




  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
        logby:this.loginService.fnGetModUserId(),
      }
    
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  } 
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  



}
